import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CardComponent } from '@vectronic/ui';
import { CDN_HOST } from '../cdn-host.injection';
import { ElasticBeltsDialogContentComponent } from './elastic-belts-dialog-content.component';

@Component({
  selector: 'vectronic-formly-elastic-moose-collar-info.dialog',
  imports: [CardComponent, ElasticBeltsDialogContentComponent],
  template: `<vectronic-card
    [title]="data.title"
    [displayClose]="true"
    (closed)="dialogRef.close()"
  >
    <ng-container body>
      <div class="card-body">
        <div md-dialog-content class="content">
          @switch (data.content) {
            @case ('one-housing') {
              <vectronic-formly-elastic-belts-dialog-content [data]="oneHousingData" />
            }
            @case ('two-housing') {
              <vectronic-formly-elastic-belts-dialog-content [data]="twoHousingData" />
            }
          }
        </div>
      </div>
    </ng-container>
  </vectronic-card>`,
  styles: ``,
})
export class ElasticMooseCollarInfoDialogComponent {
  cdnHost = inject(CDN_HOST);
  dialogRef = inject(MatDialogRef<ElasticMooseCollarInfoDialogComponent>);
  data: { title: string; content: string } = inject(MAT_DIALOG_DATA);
  oneHousingData = [
    {
      label: '',
      favorite: false,
      description:
        'The elastic effect is created with two parallel bungee cords protected by a transparent tube and running on regular belt material in a guiding track.',
      elements: [
        {
          label: 'One-housing Elastic Moose Collar',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/moose_collar_one_housing.png`,
              alt: 'One-housing Elastic Moose Collar Oval Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/moose_collar_one_housing_detail.png`,
              alt: 'One-housing Elastic Moose Collar Oval Shape Details',
            },
          ],
        },
      ],
    },
  ];
  twoHousingData = [
    {
      label: '',
      favorite: false,
      description:
        'The elastic effect is created with two parallel bungee cords protected by a transparent tube and running on regular belt material in a guiding track.',
      elements: [
        {
          label: 'Two-housing Elastic Moose Collar',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/moose_collar_two_housing.png`,
              alt: 'Two-housing Elastic Moose Collar Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/moose_collar_two_housing_detail.png`,
              alt: 'Two-housing Elastic Moose Collar Round Shape Details',
            },
          ],
        },
      ],
    },
  ];
}
